import { useState, useEffect, useCallback } from "react";

const KEY = "gridiron-theme";

export function getTheme() {
  return localStorage.getItem(KEY) || "dark";
}

export function applyTheme(t) {
  const el = document.documentElement;
  el.classList.toggle("light", t === "light");
  el.classList.toggle("dark", t === "dark");
}

export function useTheme() {
  const [theme, setTheme] = useState(getTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      localStorage.setItem(KEY, next);
      return next;
    });
  }, []);

  return { theme, toggle };
}
